import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-hardwaremessagestable',
    templateUrl: './hardwaremessagestable.component.html',
    styleUrls: ['./hardwaremessagestable.component.scss'],
    standalone: false
})
export class HardwaremessagestableComponent implements OnInit {

  @Input()
  public Data : any | null = null;

  constructor() { }

  ngOnInit(): void {
  }

}
